import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyCBWCTBKccEdjBnUfyq5Rwu-SesrrZXuJo",
    authDomain: "myproject-b3fb5.firebaseapp.com",
    projectId: "myproject-b3fb5",
    storageBucket: "myproject-b3fb5.firebasestorage.app",
    messagingSenderId: "741068111568",
    appId: "1:741068111568:web:147f7365e4970b285ae8d5",
    measurementId: "G-R6K7H47SF6"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore Database
const auth = getAuth(app);
const firestore = getFirestore(app);

export { auth, firestore };
